import React, {
	createContext,
	useContext,
	useState,
	ReactNode,
	SetStateAction,
	Dispatch,
} from "react";
import { PageMeta } from "./usePageDetails";

// Define the shape of the context value
interface PageDataContextProps {
	pageMeta: PageMeta | null;
	pageTitle: string;
}

// Create the context with a default value
const PageDataContext = createContext<PageDataContextProps | undefined>(
	undefined
);

// Create a provider component
export const PageDataProvider: React.FC<{
	children: ReactNode;
	pageMeta: PageMeta | null;
	pageTitle: string;
	setRowsClicked?: Dispatch<SetStateAction<string[]>> | undefined;
	rowsClicked?: string[];
	selectAllChecked?: boolean;
	setSelectAllChecked?: Dispatch<SetStateAction<boolean>>;
}> = ({ children, pageMeta, pageTitle }) => {
	return (
		<PageDataContext.Provider
			value={{
				pageMeta,
				pageTitle,
			}}
		>
			{children}
		</PageDataContext.Provider>
	);
};

// Custom hook to use the DataTableContext
const usePageDataContext = () => {
	const context = useContext(PageDataContext);
	if (!context) {
		throw new Error(
			"usePageDataContext must be used within a DataTableProvider"
		);
	}
	return context;
};
export default usePageDataContext;
